"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6269],{

/***/ 78524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FP": function() { return /* binding */ ExponentialBackoff; },
  "Ap": function() { return /* binding */ INITIAL_WAIT_TIME_MS; },
  "aG": function() { return /* binding */ MAX_RETRIES; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_async_to_generator.js
var _async_to_generator = __webpack_require__(30137);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_class_call_check.js
var _class_call_check = __webpack_require__(71484);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./functions/src/util/errors/HttpsError.ts + 4 modules
var HttpsError = __webpack_require__(2359);
;// CONCATENATED MODULE: ./functions/src/util/assertPositiveInteger.ts

function assertPositiveInteger(value) {
    if (!Number.isInteger(value) || value <= 0) {
        throw new HttpsError/* HttpsError */.U("invalid-argument", "Value must be a positive integer", {
            value: value
        });
    }
}

;// CONCATENATED MODULE: ./functions/src/util/sleep.ts
var sleep = function(millis) {
    return new Promise(function(resolve) {
        // eslint-disable-next-line no-restricted-globals, no-promise-executor-return
        return setTimeout(resolve, millis);
    });
};

;// CONCATENATED MODULE: ./functions/src/util/apis/ExponentialBackoff.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 




var MAX_RETRIES = 7;
var INITIAL_WAIT_TIME_MS = 1000;
var ExponentialBackoff = /*#__PURE__*/ function() {
    "use strict";
    function ExponentialBackoff(options) {
        (0,_class_call_check._)(this, ExponentialBackoff);
        this.options = options;
        assertPositiveInteger(options.maxRetries);
        assertPositiveInteger(options.initialWaitTimeMs);
    }
    var _proto = ExponentialBackoff.prototype;
    _proto.withExponentialBackoff = function withExponentialBackoff() {
        var _options = this.options, doRetry = _options.doRetry, maxRetries = _options.maxRetries, initialWaitTimeMs = _options.initialWaitTimeMs;
        return function(func) {
            var funcWrapped = function() {
                var _ref = (0,_async_to_generator._)(function() {
                    var _len, args, _key, retryCount, error, waitTimeMs;
                    var _arguments = arguments;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                    args[_key] = _arguments[_key];
                                }
                                retryCount = 0;
                                _state.label = 1;
                            case 1:
                                if (false) {}
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    func.apply(this, args)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if (!(doRetry(error) && retryCount < maxRetries)) return [
                                    3,
                                    6
                                ];
                                waitTimeMs = initialWaitTimeMs * Math.pow(2, retryCount + 1);
                                return [
                                    4,
                                    sleep(waitTimeMs)
                                ];
                            case 5:
                                _state.sent();
                                retryCount++;
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                console.error(error);
                                throw error;
                            case 7:
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    3,
                                    1
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function funcWrapped() {
                    return _ref.apply(this, arguments);
                };
            }();
            return funcWrapped;
        };
    };
    return ExponentialBackoff;
}();


/***/ }),

/***/ 86269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "streamChatFrontend": function() { return /* binding */ streamChatFrontend; }
});

;// CONCATENATED MODULE: ./functions/src/config/get-stream/timeout.ts
var STREAM_CHAT_TIMEOUT_MILLIS = 30000;

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_assert_this_initialized.js
var _assert_this_initialized = __webpack_require__(58109);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_class_call_check.js
var _class_call_check = __webpack_require__(71484);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_get_prototype_of.js
var _get_prototype_of = __webpack_require__(27642);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_super_prop_base.js


function _super_prop_base(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = (0,_get_prototype_of/* _get_prototype_of */.X)(object);
        if (object === null) break;
    }

    return object;
}


;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_get.js


function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);

            if (!base) return;

            var desc = Object.getOwnPropertyDescriptor(base, property);

            if (desc.get) return desc.get.call(receiver || target);

            return desc.value;
        };
    }

    return _get(target, property, receiver || target);
}


// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_inherits.js
var _inherits = __webpack_require__(50684);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_create_super.js + 1 modules
var _create_super = __webpack_require__(55897);
// EXTERNAL MODULE: ./node_modules/stream-chat/dist/browser.es.js
var browser_es = __webpack_require__(23274);
// EXTERNAL MODULE: ./functions/src/util/apis/ExponentialBackoff.ts + 2 modules
var ExponentialBackoff = __webpack_require__(78524);
;// CONCATENATED MODULE: ./functions/src/util/apis/withExponentialBackoff429.ts

var CONFIG_429 = {
    doRetry: function(error) {
        var response = error.response, code = error.code, message = error.message;
        var isTimeout = code === "ECONNABORTED" || message.includes("timeout");
        var isRateLimit = !response || response.status === 429;
        return isRateLimit || isTimeout;
    },
    maxRetries: ExponentialBackoff/* MAX_RETRIES */.aG,
    initialWaitTimeMs: ExponentialBackoff/* INITIAL_WAIT_TIME_MS */.Ap
};
var withExponentialBackoff429 = new ExponentialBackoff/* ExponentialBackoff */.FP(CONFIG_429).withExponentialBackoff();

;// CONCATENATED MODULE: ./functions/src/proxies/streamChatProxy.ts








var StreamChatProxy = /*#__PURE__*/ function(StreamChat) {
    "use strict";
    (0,_inherits._)(StreamChatProxy, StreamChat);
    var _super = (0,_create_super._)(StreamChatProxy);
    function StreamChatProxy(apiKey, apiSecret, options) {
        (0,_class_call_check._)(this, StreamChatProxy);
        var _this;
        _this = _super.call(this, apiKey, apiSecret, options);
        _this.deleteUser = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "deleteUser", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.deleteUsers = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "deleteUsers", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.deactivateUser = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "deactivateUser", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.deactivateUsers = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "deactivateUsers", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.channel = _get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "channel", _this).bind((0,_assert_this_initialized._)(_this));
        _this.createToken = _get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "createToken", _this).bind((0,_assert_this_initialized._)(_this));
        _this.deleteChannels = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "deleteChannels", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.queryChannels = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "queryChannels", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.partialUpdateUser = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "partialUpdateUser", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.partialUpdateUsers = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "partialUpdateUsers", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.upsertUser = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "upsertUser", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.upsertUsers = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "upsertUsers", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.banUser = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "banUser", _this).bind((0,_assert_this_initialized._)(_this)));
        _this.unbanUser = withExponentialBackoff429(_get(((0,_assert_this_initialized._)(_this), (0,_get_prototype_of._)(StreamChatProxy.prototype)), "unbanUser", _this).bind((0,_assert_this_initialized._)(_this)));
        return _this;
    }
    return StreamChatProxy;
}(browser_es/* StreamChat */.c8);

;// CONCATENATED MODULE: ./src/config/get-stream/streamChatFrontend.ts


var streamChatFrontend = new StreamChatProxy("328cw6xmusuf", undefined, {
    timeout: STREAM_CHAT_TIMEOUT_MILLIS
});


/***/ })

}]);